import { decimalToPercent } from '@calculations/utilities/decimal-places';
import { UnreachableCaseError } from '@lib/validation/errors';
import {
  PriceSegmentType,
  resultsMetadataSchema,
} from '@snap-types/models/price-segment';

export function extractValueFromResultsMetadata(
  resultsMetadata: unknown,
): string {
  const result = resultsMetadataSchema.safeParse(resultsMetadata);

  if (!result.success) {
    return '-';
  }

  const { segment } = result.data;

  switch (segment) {
    case PriceSegmentType.CustomerPotential:
      return result.data.customerPotential ?? '-';
    case PriceSegmentType.CustomerPortals:
      return result.data.hasCustomerPortals ? 'Yes' : 'No';
    case PriceSegmentType.ProductOperationsCount:
      return result.data.operationsCount?.toString() ?? '-';
    case PriceSegmentType.ProductComplexity:
      return result.data.productComplexity ?? '-';
    case PriceSegmentType.MarketIndustry:
      return result.data.marketIndustry ?? '-';
    case PriceSegmentType.LastTransactionAge:
      return result.data.lastTransactionAgeInDays?.toString() ?? '-';
    case PriceSegmentType.LastGrossMargin:
      return result.data.lastGrossMargin
        ? `${decimalToPercent(result.data.lastGrossMargin)}%`
        : '-';
    default:
      throw new UnreachableCaseError(segment);
  }
}
